import React from 'react';
import styled, { css } from 'styled-components';
import { CloseSvg, DefaultLabelIconSvg } from '../../icons';
import device from 'utils/device';

export const Label = (props) => {
  const {
    boldText,
    text,
    iconPosition,
    state,
    big,
    icon,
  } = props;

  let defaultIcon = icon;

  if (iconPosition && !icon) {
    if (state === 'default') {
      defaultIcon = <DefaultLabelIconSvg color={window?.settings?.primary_color ?? '#1DBD6B'} />
    }
    if (state === 'error') {
      defaultIcon = <CloseSvg width="18" height="18" color="#FD2020" />
    }
  }

  return (
    <Wrapper state={state} big={big}>
      {iconPosition === 'left' &&
        <div className="mr-1.5">
          {defaultIcon}
        </div>
      }
      <div className="flex">
        {boldText &&
          <BoldText>
            {boldText}
          </BoldText>
        }
        <div>
          {text}
        </div>
      </div>
      {iconPosition === 'right' &&
        <div className="ml-1.5">
          {defaultIcon}
        </div>
      }
    </Wrapper>
  )
}

const Wrapper = styled.div`
  height: 18px;
  display: inline-flex;
  align-items: center;
  font-size: 9.39px;
  font-weight: 400;

  ${p => p.state === 'underline' && css`
    text-decoration: underline;
  `}
  
  ${p => p.state === 'default' && css`
    background-color: #F4FCF8;
    color: #1AAA60;
  `}

  ${p => p.state === 'error' && css`
    background-color: #FFF4F4;
    color: #FD2020;
  `}

  ${p => p.state === 'other' && css`
    background-color: #F3F5F5;
    color: ${window?.settings?.secondary_color ?? '#04333b'};
  `}

  padding-left: ${p => p.big ? '22px' : '7.17px'};
  padding-right: ${p => p.big ? '22px' : '7.17px'};

  @media ${device.mobileL} {
    height: ${p => p.big ? '39px' : '23px'};
    font-size: ${p => p.big ? '14px' : '12px'};
  }
`;

const BoldText = styled.div`
  font-weight: 600;
`;

export default Label;